function init() {
  $("img").on("dragstart", function(e) {
    e.preventDefault();
  });
}

module.exports = { init };